import React from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "../../lib/api";

export function LogoStrip() {
  const { data } = useQuery({ queryKey: ["customers"], queryFn: () => get("/customers") });
  const items = data || [];
  if (!items.length) return null;
  return (
    <div className="border-y border-line">
      <div className="container-bc flex items-center gap-6 overflow-x-auto py-4">
        <span className="eyebrow whitespace-nowrap">Used by teams at</span>
        <ul className="flex items-center gap-8">
          {items.map((c) => (
            <li key={c.id} className="whitespace-nowrap font-mono text-sm text-ink-400 tracking-tight">{c.name}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
